<template>
  <async-component :asyncFunction="loadStats" #default="{ loading }">
    <panel prompt="Среди закрытых на сегодня">
      <template #title>
        Завершенные процедуры
      </template>
      <template #content>
        <div class="layout">
          <text-card v-for="(measure, index) in getStats(loading)" :key="index"
            :loading="loading"
          >
            <template #title>{{ measure.name }}</template>
            <template #value>{{ measure.count }}</template>
            <template #unit>{{ measure.unit }}</template>
          </text-card>
        </div>
      </template>
    </panel>

  </async-component>
</template>

<script>
import AsyncComponent from '@/components/AsyncComponent.vue'
import Panel from '@/components/dashboard/widgets/templates/Panel.vue'
import TextCard from '@/components/dashboard/widgets/templates/TextCard.vue'
import { DataService } from '@/services/DataService.js'
import { pluralForm } from '@/utils/pluralForms'

export default {
  components: {
    AsyncComponent,
    Panel,
    TextCard
  },
  methods: {
    loadStats () {
      const params = {
        companyIds: [this.$store.getters['session/user'].companyId]
      }
      return DataService.getClosedProceduresStats(params)
        .then(({ data: { closedProceduresStats: stats } }) => {
          this.stats = stats
            ? [{
              name: 'C победителем',
              count: stats.withWinner,
              unit: pluralForm(stats.withWinner, ['конкурс', 'конкурса', 'конкурсов'])
            }, {
              name: 'Без победителя',
              count: stats.withoutWinner,
              unit: pluralForm(stats.withoutWinner, ['конкурс', 'конкурса', 'конкурсов'])
            }]
            : []
        })
    },
    getStats (loading) {
      return loading ? [{}, {}] : this.stats
    },
    navigateTo (measure) {
      this.$router.push({ name: 'procedures', query: { statuses: measure.id } })
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: .5rem;
  border-radius: .25rem;
}
@media only screen and (min-width: 60em) {
  .layout {
    grid-gap: .85rem;
    grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  }
}
</style>
